import debugHelper from './debug'
import msgbus from '../msgBus'
import i18n from '../lang/index'

/**
 * 时间操作工具类
 */
var dateHelper = {
	/**
	 * 字符串转时间戳
	 * @param {String} str 时间字符串
	 */
	string2Timestamp: function (str) {
		return Date.parse(new Date(str)) / 1000
	},

	/**
	 * 时间戳转字符串(暂未用到)
	 * @param {int} time 时间戳, 单位(秒)
	 */
	timestamp2String: function (time) {
		return new Date(parseInt(time) * 1000).toLocaleString()
		// return new Date(parseInt(time) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
	},


	/**
	 * 时间戳转本地时间(目前只有国区格式)
	 * @param {int} time 时间戳, 单位(秒)
	 */
	timestamp2LocalTime: function (time) {
		var timeTmp = new Date(parseInt(time) * 1000)

		if (time == 0) {
			return 0
		}

		return (
			timeTmp.getFullYear() +
			'-' +
			(timeTmp.getMonth() + 1 < 10 ? '0' + (timeTmp.getMonth() + 1) : timeTmp.getMonth() + 1) +
			'-' +
			(timeTmp.getDate() < 10 ? '0' + timeTmp.getDate() : timeTmp.getDate()) +
			' ' +
			(timeTmp.getHours() < 10 ? '0' + timeTmp.getHours() : timeTmp.getHours()) +
			':' +
			(timeTmp.getMinutes() < 10 ? '0' + timeTmp.getMinutes() : timeTmp.getMinutes())
		)
	},

	/**
		 * 时间戳转本地日期(目前只有国区格式)
		 * @param {int} time 时间戳, 单位(秒)
		 */
	timestamp2LocalDate: function (time) {
		var timeTmp = new Date(parseInt(time) * 1000)

		if (time == 0) {
			return 0
		}

		return (
			timeTmp.getFullYear() +
			'-' +
			(timeTmp.getMonth() + 1 < 10 ? '0' + (timeTmp.getMonth() + 1) : timeTmp.getMonth() + 1) +
			'-' +
			(timeTmp.getDate() < 10 ? '0' + timeTmp.getDate() : timeTmp.getDate())
		)
	},

	/**
	 * 时间戳转"小时:分钟"(目前只有国区格式)
	 * @param {int} time 时间戳, 单位(秒)
	 */
	timestamp2LocalHourMinute: function (time) {
		var timeTmp = new Date(parseInt(time) * 1000)

		if (time == 0) {
			return 0
		}

		return (
			(timeTmp.getHours() < 10 ? '0' + timeTmp.getHours() : timeTmp.getHours()) +
			':' +
			(timeTmp.getMinutes() < 10 ? '0' + timeTmp.getMinutes() : timeTmp.getMinutes())
		)
	},

	/**
	 * 获取时间戳, 单位(秒)
	 */
	getLocalTimestamp: function () {
		return Date.parse(new Date()) / 1000
	},

	/**
	 * 计算剩余时间, 单位(分钟)
	 * @param {int} time 时间, 单位(秒)
	 */
	time2Remaining: function (time) {
		return (time / 60).toFixed() + i18n.t('分钟')
	},

	/**
	 * Date格式转时间戳
	 * @param {Date} date 日期
	 */
	date2Timestamp: function (date) {
		return Date.parse(date) / 1000
	},

	/**
	 * 获取上月1号的时间戳, 单位(秒)
	 */
	getLastMonthTimestamp: function () {
		var dateTmp = new Date()

		dateTmp.setMonth(dateTmp.getMonth() - 1)
		dateTmp.setDate(1)
		dateTmp.setHours(0, 0, 0, 0)
		return Date.parse(dateTmp) / 1000
	},

	/**
	 * 获取本月1号的时间戳, 单位(秒)
	 */
	getThisMonthTimestamp: function () {
		var dateTmp = new Date()
		dateTmp.setDate(1)
		dateTmp.setHours(0, 0, 0, 0)
		return Date.parse(dateTmp) / 1000
	},

	/**
	 * 获取本年1号的时间戳, 单位(秒)
	 */
	getThisYearTimestamp: function () {
		var dateTmp = new Date()
		dateTmp.setMonth(0)
		dateTmp.setDate(1)
		dateTmp.setHours(0, 0, 0, 0)
		return Date.parse(dateTmp) / 1000
	},

	/**
	 * 获取去年今日的时间戳, 单位(秒)
	 */
	getLastYearTodayTimestamp: function () {
		var dateTmp = new Date()
		dateTmp.setFullYear(dateTmp.getFullYear() - 1)
		dateTmp.setHours(0, 0, 0, 0)
		return Date.parse(dateTmp) / 1000
	},

	/**
	 * 获取去年1号的时间戳, 单位(秒)
	 */
	getLastYearTimestamp: function () {
		var dateTmp = new Date()
		dateTmp.setFullYear(dateTmp.getFullYear() - 1)
		dateTmp.setMonth(0)
		dateTmp.setDate(1)
		dateTmp.setHours(0, 0, 0, 0)
		return Date.parse(dateTmp) / 1000
	},

	/**
	 * 将预约日期、预约时段转化为时间戳
	 * @param {String} bookDate 预约日期
	 * @param {String} bookTime 预约时段
	 */
	getTimestampFromBookTime: function (bookDate, bookTime) {
		var dateTmp = new Date(bookDate)

		var timeTmp = []

		switch (bookTime) {
			case '全天':
				dateTmp.setHours(6)
				timeTmp.push(Date.parse(dateTmp) / 1000)

				dateTmp.setDate(dateTmp.getDate() + 1)
				dateTmp.setHours(6)
				timeTmp.push(Date.parse(dateTmp) / 1000)
				break

			case '上午':
				dateTmp.setHours(6)
				timeTmp.push(Date.parse(dateTmp) / 1000)

				dateTmp.setHours(12)
				timeTmp.push(Date.parse(dateTmp) / 1000)
				break

			case '下午':
				dateTmp.setHours(13)
				timeTmp.push(Date.parse(dateTmp) / 1000)

				dateTmp.setHours(18)
				timeTmp.push(Date.parse(dateTmp) / 1000)
				break

			case '晚上':
				dateTmp.setHours(19)
				timeTmp.push(Date.parse(dateTmp) / 1000)

				dateTmp.setDate(dateTmp.getDate() + 1)
				dateTmp.setHours(6)
				timeTmp.push(Date.parse(dateTmp) / 1000)
				break
		}

		return timeTmp
	},

	/**
	 * 将时间戳转化为预约日期、预约时段
	 * @param {Date} date 起始时间
	 * @param {Date} date2 终止时间
	 */
	getBookTimeFromDatestamp(date, date2) {
		var dateTmp = new Date(date * 1000)
		var bookDate = ''
		var bookTime = ''

		bookDate =
			dateTmp.getFullYear() +
			'-' +
			(dateTmp.getMonth() + 1 < 10 ? '0' + (dateTmp.getMonth() + 1) : dateTmp.getMonth() + 1) +
			'-' +
			(dateTmp.getDate() < 10 ? '0' + dateTmp.getDate() : dateTmp.getDate())

		switch (dateTmp.getHours()) {
			case 6:
			case 7:
			case 8:
			case 9:
			case 10:
			case 11:
			case 12:
				bookTime = '上午'

				var dateTmp2 = new Date(date2 * 1000)
				if (dateTmp.getDate() != dateTmp2.getDate()) {
					bookTime = '全天'
				}

				break

			case 13:
			case 14:
			case 15:
			case 16:
			case 17:
				bookTime = '下午'
				break

			case 18:
			case 19:
			case 20:
			case 21:
			case 22:
			case 23:
			case 24:
			case 0:
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
				bookTime = '晚上'
				break
		}

		return { bookDate, bookTime }
	},

	/**
	 * 获取今天之后num天的日期
	 * @param {int} num 距今多少天, 今天为0
	 */
	getDayAfterToday(num) {
		var date = new Date()
		var tmp = date.getDate() + num
		date.setDate(tmp)
		date.setHours(0, 0, 0, 0)
		return date
	},

	/**
	 * 暂未用到
	 * @param {Date} date
	 */
	getDaysByMonth(date) {
		var days = 0

		switch (date.getMonth() + 1) {
			case 1:
				days = 31
				break

			case 2:
				var year = date.getFullYear()
				if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
					days = 29
				} else {
					days = 28
				}
				break

			case 3:
				days = 31
				break

			case 4:
				days = 30
				break

			case 5:
				days = 31
				break

			case 6:
				days = 30
				break
			case 7:
				days = 31
				break

			case 8:
				days = 31
				break

			case 9:
				days = 30
				break

			case 10:
				days = 31
				break

			case 11:
				days = 30
				break

			case 12:
				days = 31
				break
		}
		return days
	},

	/**
	 * 获取本地日期
	 * @param {Date} date
	 */
	getDate(date) {
		return (
			date.getFullYear() +
			'-' +
			(date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
			'-' +
			(date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
		)
	},

	/**
	 * dateStr1 < dateStr2, return true,
	 * dateStr1 >= dateStr2, return false
	 * @param {String} dateStr1 字符串1
	 * @param {String} dateStr2 字符串2
	 */
	compareDateString(dateStr1, dateStr2) {
		// console.log('调试代码')
		var date1 = Date.parse(new Date(dateStr1))
		var date2 = Date.parse(new Date(dateStr2))

		if (date1 <= date2) {
			return true
		} else {
			return false
		}
	},

	/** 返回时间间隔（例：30天）
	 * return dateStr2 - dateStr2
	 * @param {String} dateStr1 字符串1 例 2020-01-01
	 * @param {String} dateStr2 字符串2 例 2020-01-29
	*/
	apartDateString(dateStr1, dateStr2) {
		// console.log('调试代码')
		var date1 = Date.parse(new Date(dateStr1))
		var date2 = Date.parse(new Date(dateStr2))

		var apart = (date2 / 1000 - date1 / 1000) / 86400  // 1天=86400秒
		return apart
	},

	unixFromNow(unix, now, minScale = 'second') {
		if (msgbus.vm.getPlatform() === 'iOS') {
			var ver = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
			if (ver) {
				ver = parseInt(ver[1], 10)
				if (ver < 14) { // Intl.RelativeTimeFormat
					return ''
				}
			}
		}

		if (!now) {
			now = Math.floor(Date.now() / 1000)
		}
		let fromVal = unix - now
		// Math.floor() 返回小于或等于给定数字的最大整数
		// Math.ceil() 返回大于或等于给定数字的最小整数
		const __floor = fromVal > 0 ? Math.floor : Math.ceil
		let timeString = ''
		const scales = {
			second: [0, 60],
			minute: [60, 3600],
			hour: [3600, 86400],
			day: [86400, 2592000],
			month: [2592000, 31536000],
			year: [31536000],
		}
		if (Math.abs(fromVal) < scales[minScale][0]) {
			fromVal = scales[minScale][0] * (fromVal < 0 ? -1 : 1)
		}

		// 确保 fromVal 是有限数字  
		if (!Number.isFinite(fromVal)) {
			return 'error'
		}

		if (Math.abs(fromVal) < scales.second[1]) {
			timeString = i18n.t('已等待{number}秒', { number: Math.abs(fromVal) })
		} else if (Math.abs(fromVal) < scales.minute[1]) {
			timeString = i18n.t('已等待{number}分钟', { number: Math.abs(__floor(fromVal / scales.minute[0])) })
		} else if (Math.abs(fromVal) < scales.hour[1]) {
			timeString = i18n.t('已等待{number}小时', { number: Math.abs(__floor(fromVal / scales.hour[0])) })
		} else if (Math.abs(fromVal) < scales.day[1]) {
			timeString = i18n.t('已等待{number}天', { number: Math.abs(__floor(fromVal / scales.day[0])) })
		} else if (Math.abs(fromVal) < scales.month[1]) {
			timeString = i18n.t('已等待{number}月', { number: Math.abs(__floor(fromVal / scales.month[0])) })
		} else {
			timeString = i18n.t('已等待{number}年', { number: Math.abs(__floor(fromVal / scales.year[0])) })
		}
		return timeString

	}
}

export default dateHelper
